import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { getUserFirstName } from '@/lib/supabase'
import { Logo } from '@/components/Logo'

export function WelcomePage() {
  const navigate = useNavigate()
  const { session } = useAuthStore()
  const firstName = getUserFirstName(session?.user ?? null)

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0f172a] px-6">
      <div className="w-full max-w-lg text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-10">
          <Logo size="lg" variant="auto" />
        </div>

        {/* Welcome Card */}
        <div className="bg-slate-50 dark:bg-slate-800/50 rounded-2xl p-10 border border-slate-200 dark:border-slate-700">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#4f46e5] to-[#312e81] flex items-center justify-center">
            <span className="material-symbols-outlined text-white text-3xl">waving_hand</span>
          </div>

          <h1 className="text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight mb-3">
            Welcome to URLzippy, {firstName}!
          </h1>
          <p className="text-slate-500 dark:text-slate-400 text-lg mb-8 leading-relaxed">
            You're all set. Here's what you can do:
          </p>

          <div className="grid gap-4 text-left mb-10">
            <div className="flex items-start gap-3">
              <span className="material-symbols-outlined text-[#4f46e5] mt-0.5">add_link</span>
              <div>
                <p className="font-semibold text-slate-900 dark:text-white">Create short links</p>
                <p className="text-sm text-slate-500 dark:text-slate-400">Turn long URLs into clean, shareable links</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="material-symbols-outlined text-[#4f46e5] mt-0.5">bar_chart</span>
              <div>
                <p className="font-semibold text-slate-900 dark:text-white">Track analytics</p>
                <p className="text-sm text-slate-500 dark:text-slate-400">See who's clicking and where they're from</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="material-symbols-outlined text-[#4f46e5] mt-0.5">qr_code_2</span>
              <div>
                <p className="font-semibold text-slate-900 dark:text-white">Generate QR codes</p>
                <p className="text-sm text-slate-500 dark:text-slate-400">Share your links offline with custom QR codes</p>
              </div>
            </div>
          </div>

          <button
            onClick={() => navigate('/dashboard', { replace: true })}
            className="w-full h-12 bg-[#4f46e5] hover:bg-[#4338ca] text-white rounded-xl font-semibold text-sm transition-all shadow-lg shadow-indigo-500/30 flex items-center justify-center gap-2"
          >
            Get Started
            <span className="material-symbols-outlined text-lg">arrow_forward</span>
          </button>
        </div>
      </div>
    </div>
  )
}
